import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { CheckPermissionRender } from "../../../helpers/checkPermission";
import permissions from "../../../config/permissions";

export default function getOrganizationsTableData(items, onEdit, setOpenAccountPopup) {
  const columns = [
    { Header: "name", accessor: "name", align: "left" },
    { Header: "address", accessor: "address", align: "center" },
    { Header: "phone", accessor: "phone", align: "center" },
    { Header: "status", accessor: "status", align: "center" },
    { Header: "actions", accessor: "actions", align: "center" },
  ];

  return {
    columns: columns,
    rows: items.map((item) => {
      return {
        name: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {item.name}
          </MDTypography>
        ),
        address: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {item.address}
          </MDTypography>
        ),
        phone: (
          <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
            {item.phone_number}
          </MDTypography>
        ),
        status: (
          <MDBox ml={-1}>
            <MDBadge
              badgeContent={item.is_active ? "Active" : "Inactive"}
              color={item.is_active ? "success" : "error"}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        actions: (
          <>
            <CheckPermissionRender permissions={permissions().organization().update().list()}>
              <MDTypography
                mr={2}
                onClick={() => {
                  onEdit(item);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Edit
              </MDTypography>
            </CheckPermissionRender>
            <CheckPermissionRender permissions={permissions().organization().update().list()}>
              <MDTypography
                mr={2}
                onClick={() => {
                  setOpenAccountPopup(item);
                }}
                component="a"
                href="#"
                variant="caption"
                color="text"
                fontWeight="medium"
              >
                Accounts
              </MDTypography>
            </CheckPermissionRender>
          </>
        ),
      };
    }),
  };
}
